"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MessagePopup_1 = require("./MessagePopup");
const BodyPopup_1 = require("./BodyPopup");
const styles_1 = require("./styles");
exports.Popup = (props) => {
    function chooseModalType() {
        switch (props.type) {
            case "message":
                return react_1.default.createElement(MessagePopup_1.MessagePopup, Object.assign({}, props));
            case "body":
                return react_1.default.createElement(BodyPopup_1.BodyPopup, Object.assign({}, props));
            default:
                return null;
        }
    }
    if (props.visible) {
        return react_1.default.createElement(styles_1.Modal, null, chooseModalType());
    }
    else
        return null;
};
